import React from 'react'
import './PageManager.css'
import PropTypes from 'prop-types'
//MUI
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
function PageManager(props) {
  const { state, setState, viewportScales, setViewportScales, numPages } = props

  const goToPrevPage = () => {
    if (state.pageNumber > 1) setState({ ...state, pageNumber: state.pageNumber - 1 })
    else if (state.pageNumber === 1) setState({ ...state, pageNumber: numPages })
  }
  const goToNextPage = () => {
    if (state.pageNumber < numPages) setState({ ...state, pageNumber: state.pageNumber + 1 })
    else if (state.pageNumber === numPages) setState({ ...state, pageNumber: 1 })
  }
  return (
    <>
      <div className='pageManager-container'>
        <ArrowBackIosIcon fontSize='small' className='page-arrow' onClick={goToPrevPage} />
        <p className='page-label '>
          Page {state.pageNumber} of {numPages}
        </p>
        <ArrowForwardIosIcon fontSize='small' className='page-arrow' onClick={goToNextPage} />
      </div>
      <div className='radio-toolbar'>
        <div>
          <input
            type='radio'
            id='radio1x'
            value='1x'
            checked={viewportScales[state.pageNumber - 1] === 1}
            onChange={() => setViewportScales(viewportScales.map((scale, index) => (index === state.pageNumber - 1 ? 1 : scale)))}
          />
          <label htmlFor='radio1x'>1x</label>
        </div>
        <div>
          <input
            type='radio'
            id='radio1.5x'
            value='1.5x'
            checked={viewportScales[state.pageNumber - 1] === 1.5}
            onChange={() =>
              setViewportScales(viewportScales.map((scale, index) => (index === state.pageNumber - 1 ? 1.5 : scale)))
            }
          />
          <label htmlFor='radio1.5x'>1.5x</label>
        </div>
        <div>
          <input
            type='radio'
            id='radio2x'
            value='2x'
            checked={viewportScales[state.pageNumber - 1] === 2}
            onChange={() => setViewportScales(viewportScales.map((scale, index) => (index === state.pageNumber - 1 ? 2 : scale)))}
          />
          <label htmlFor='radio2x'>2x</label>
        </div>
      </div>
    </>
  )
}

PageManager.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  viewportScales: PropTypes.arrayOf(PropTypes.number).isRequired,
  setViewportScales: PropTypes.func.isRequired,
  numPages: PropTypes.number,
}

export default PageManager
